import { useContext } from "react";
import { CategoryContext, CategoryContextValue } from "./CategoryContext";

export const useCategoryContext = () => useContext<CategoryContextValue>(CategoryContext);
